import { DATA_BASE_URL } from '@lib/constants';

const HeroSection = () => {
  return (
    <section
      className="relative py-20 px-4 sm:px-6 lg:px-8 min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundColor: 'var(--color-body-bg)',
      }}
    >
      {/* Background accent shapes */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          background: `radial-gradient(circle at 20% 50%, var(--color-accent-6), transparent 50%),
                       radial-gradient(circle at 80% 80%, var(--color-accent-6), transparent 50%)`,
        }}
      />

      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 md:space-y-8">
            {/* Title */}
            <div className="space-y-3 md:space-y-4">
              <h1
                className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                Musical Excellence
              </h1>
              <p
                className="text-xl sm:text-2xl font-semibold"
                style={{ color: 'var(--color-accent-6)' }}
              >
                Violinist
              </p>
            </div>

            {/* Description */}
            <p
              className="text-base sm:text-lg leading-relaxed max-w-2xl"
              style={{ color: 'var(--color-subtle)' }}
            >
              I am passionate about classical violin performance with ABRSM certifications. I am dedicated to developing my musical skills through rigorous practice and live performances across multiple venues and events.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 sm:gap-6 pt-4 sm:pt-8">
              <div className="space-y-1 sm:space-y-2">
                <div
                  className="text-3xl sm:text-4xl font-bold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  3
                </div>
                <p
                  className="text-xs sm:text-sm"
                  style={{ color: 'var(--color-muted)' }}
                >
                  ABRSM Certifications
                </p>
              </div>
              <div className="space-y-1 sm:space-y-2">
                <div
                  className="text-3xl sm:text-4xl font-bold"
                  style={{ color: 'var(--color-accent-6)' }}
                >
                  Grade 5
                </div>
                <p
                  className="text-xs sm:text-sm"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Music Theory
                </p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div
            className="relative h-80 sm:h-96 lg:h-full rounded-2xl overflow-hidden shadow-card-hover order-first lg:order-last"
            style={{
              borderColor: 'var(--color-accent-4)',
              borderWidth: '2px',
              borderStyle: 'solid',
              backgroundColor: 'var(--color-theme-2)',
            }}
          >
            <img
              src={`${DATA_BASE_URL}/data/PROFILE PICTURE SRIHAAN.webp`}
              alt="Violin Performance"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div
              className="absolute inset-0 flex items-center justify-center"
              style={{
                background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0))',
              }}
            >
              <svg
                className="w-16 h-16 sm:w-24 sm:h-24 opacity-50"
                fill="currentColor"
                style={{ color: 'var(--color-accent-6)' }}
                viewBox="0 0 24 24"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
